module.exports = __webpack_public_path__ + "assets/649b439257a6d6e4a145fd6a00776970.png";